import { SubscriptionUserData } from "../reducers/subscriptionReducer";
import { sendUserData } from "../services/subscription";

export const sendUserInfo = (data, addToast) => async (dispatch) => {
  dispatch(SubscriptionUserData.requestSendUserData());
  try {
    dispatch(
      SubscriptionUserData.successfulSendUserData({
        result: data,
      })
    );
    if (addToast) {
        addToast("Gracias por dejar tus datos!", {
          appearance: "success",
          autoDismiss: true,
        });
      }
    await sendUserData({...data, date: new Date()});
  } catch (e) {
    // dispatch(MessageActions.showMessage({ message: e.message, variant: 'error' }));
    dispatch(SubscriptionUserData.errorSendUserData(e));
  }
};
